import { FieldsPaneField } from "./field.component";

export * from "./field.component";
export default FieldsPaneField;

FieldsPaneField.define("fields-pane-field");

declare global {
    interface HTMLElementTagNameMap {
        "fields-pane-field": FieldsPaneField;
    }
}
